import React from 'react';
import BasicFroalaEditor from './basicFroala/BasicFroalaEditor';

function BasicBannerFroala(props) {
    const { content, onUpdateContent, elementId, campaignMessageTemplateTypes, ...restProps } =
        props;

    const renderFroala = () => {
        switch (Number(content.template_type)) {
            case campaignMessageTemplateTypes.bannerTemplate1:
                return (
                    <BasicFroalaEditor
                        {...restProps}
                        content={content.imgMobileElements}
                        onUpdateContent={onUpdateContent}
                        isReadOnly={false}
                        type="image"
                        customStyle={getCustomBannerStyle(
                            campaignMessageTemplateTypes,
                            Number(content.template_type)
                        )}
                    />
                );
            case campaignMessageTemplateTypes.bannerTemplate2:
                return (
                    <>
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.textAreaElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="textarea"
                            customStyle={getCustomBannerStyle(
                                campaignMessageTemplateTypes,
                                Number(content.template_type)
                            )}
                        />
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.buttonElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="button"
                        />
                    </>
                );
            case campaignMessageTemplateTypes.bannerTemplate3:
                return (
                    <>
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.imgMobileElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="image"
                            customStyle={getCustomBannerStyle(
                                campaignMessageTemplateTypes,
                                Number(content.template_type)
                            )}
                        />
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.buttonElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="button"
                        />
                    </>
                );
            default:
                return (
                    <BasicFroalaEditor
                        {...restProps}
                        content={content.imgMobileElements}
                        onUpdateContent={onUpdateContent}
                        isReadOnly={false}
                        type="image"
                    />
                );
        }
    };
    return renderFroala();
}

export const getCustomBannerStyle = (campaignMessageTemplateTypes, type) => {
    switch (type) {
        case campaignMessageTemplateTypes.bannerTemplate1:
            return {
                textAlign: ' center',
                overflow: 'hidden',
            };
        case campaignMessageTemplateTypes.bannerTemplate2:
        case campaignMessageTemplateTypes.bannerTemplate3:
        default:
            return {
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                alignItems: 'center',
                justifyContent: 'space-around',
                textAlign: ' center',
                overflow: 'hidden',
                padding: '12px 16px 12px 12px'
            };
    }
};

export default BasicBannerFroala;
